/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AlertConfigQueryContract} from './contracts/alert-config-query.contract';
import {AlertConfigResultContract} from './contracts/alert-config-result.contract';
import httpOptionsConfiguration from '../../generic/configuration/http-options.configuration';
import {AlertConfigCommandContract} from './contracts/alert-config-command.contract';
import {AlertConfigCommandResultBaseContract} from './contracts/alert-config-command-result-base.contract';
import {AlertConfigDetailContract} from './contracts/alert-config-detail.contract';

@Injectable({
    providedIn: 'root'
})
export class AlertsConfigApi {

    private alertConfigBaseUrl = `${environment.settingsBaseUrl}/api/alertConfig`;

    constructor(private http: HttpClient) {
    }

    /**
     * Gets Alerts from the BE
     * @param alertConfigQuery the search query criteria
     */
    getAlertsConfig = (alertConfigQuery: AlertConfigQueryContract): Observable<AlertConfigResultContract> =>
            this.http.post<AlertConfigResultContract>(`${this.alertConfigBaseUrl}/search`, alertConfigQuery, httpOptionsConfiguration);

    /**
     * Create a new alert config
     * @param alert the new alert data
     */
    createAlertConfig = (alert: AlertConfigCommandContract): Observable<AlertConfigCommandResultBaseContract> =>
            this.http.post<AlertConfigCommandResultBaseContract>(this.alertConfigBaseUrl, alert, httpOptionsConfiguration);

    /**
     * Get a alert config detail
     * @param alertConfigCode the alert config code
     */
    getAlertConfigDetail = (alertConfigCode: string): Observable<AlertConfigDetailContract> =>
            this.http.get<AlertConfigDetailContract>(`${this.alertConfigBaseUrl}/detail/${alertConfigCode}`, httpOptionsConfiguration);

    /**
     * Edit a alert config detail
     * @param alertConfigCode the alert config code to edit
     * @param alertConfig the new alert config changes to edit
     */
    editAlertConfig = (alertConfigCode: string, alertConfig: AlertConfigCommandContract):
            Observable<void> => this.http.put<void>(
            `${this.alertConfigBaseUrl}/${alertConfigCode}`, alertConfig, httpOptionsConfiguration);

    /**
     * Deletes an alert config
     * @param alertConfigCode the alert config code to delete
     */
    deleteAlertConfig(alertConfigCode: string): Observable<void> {
        return this.http.delete<void>(`${this.alertConfigBaseUrl}/${alertConfigCode}`);
    }
}

